import React, { memo } from "react";

import { classNames } from "helpers";
import Logo from "ui/modules/public/components/Logo/Logo";

import ShowcaseBackdrop from "./ShowcaseBackdrop";
import ShowcaseStage from "./ShowcaseStage";
import { ShowcaseIntroProps } from "./types";

/**
 * Lijevi plavi panel modala: logo, pozornica s karticama scene, a ispod naslov i opis. Kod
 * čarobnjaka još "Korak X od Y" i točkice koraka; modal s jednim korakom ih nema.
 */
const ShowcaseIntro: React.FC<ShowcaseIntroProps> = ({ sceneKey, title, description, stepCurrent, stepCount, children }) => {
  const hasSteps = stepCurrent !== undefined && !!stepCount && stepCount > 1;

  return (
    <div className="relative flex flex-col w-full h-full bg-blue-700 overflow-hidden">
      <ShowcaseBackdrop />
      <Logo variant="light" animated className="absolute top-8 left-8 z-10" />

      <div className="relative flex flex-1 min-h-0 items-center justify-center select-none pointer-events-none" aria-hidden="true">
        {/* `key`: nova scena iznova montira pozornicu, pa kartice ponovno ulete. */}
        <ShowcaseStage key={sceneKey}>{children}</ShowcaseStage>
      </div>

      <div className="relative px-8 pb-12 text-center">
        {hasSteps && (
          <div className="text-xs font-semibold uppercase tracking-widest text-blue-200">
            Korak {stepCurrent + 1} od {stepCount}
          </div>
        )}
        <div key={sceneKey} className="motion-safe:animate-showcaseFadeIn">
          <div className="mt-2 text-3xl font-bold leading-tight text-white">{title}</div>
          {/* Visina dva retka: opisi su različite duljine, a scena iznad ne smije skakati. */}
          <p className="mt-3 mx-auto max-w-md min-h-[3rem] text-base text-blue-100">{description}</p>
        </div>
        {hasSteps && (
          <div className="flex items-center justify-center gap-2 mt-6">
            {Array.from({ length: stepCount }, (_, index) => (
              <span
                key={index}
                className={classNames(
                  "h-1.5 rounded-full transition-all duration-300",
                  index === stepCurrent ? "w-6 bg-amber-400" : "w-1.5 bg-white/40"
                )}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(ShowcaseIntro);
